export default __webpack_public_path__ + "static/media/Group3398-tata-neu@3x.c3376ab6.png";